<template>
    <div>
        <div class="login-box">
            <div class="login-logo">
                <a href="/"><b>Login</b></a>
            </div>
            <!-- /.login-logo -->
            <div class="login-box-body">
                <p class="login-box-msg">Inicia sesión para acceder</p>

                <div class="alert alert-warning" role="alert" v-if="error !== null">{{ error }}</div>

                <form @submit.prevent="loginSubmit" name="login" action="/" method="post">
                    <div class="form-group has-feedback">
                        <input v-model="username" type="email" class="form-control" placeholder="Email" autocomplete="email">
                        <span class="glyphicon glyphicon-envelope form-control-feedback"></span>
                    </div>
                    <div class="form-group has-feedback">
                        <input v-model="password" type="password" class="form-control" placeholder="Contraseña" autocomplete="password">
                        <span class="glyphicon glyphicon-lock form-control-feedback"></span>
                    </div>
                    <div class="row">
                        <!-- /.col -->
                        <div class="col-xs-4 float-right" v-if="!loading">
                            <button type="submit" class="btn btn-primary btn-block btn-flat">Acceder</button>
                        </div>
                        <!-- /.col -->

                        <!-- /.col -->
                        <div class="col-xs-4" style="text-align: center;" v-if="loading">
                            <div class="overlay">
                                <i class="fa fa-refresh fa-spin"></i>
                            </div>
                        </div>
                        <!-- /.col -->
                    </div>

                </form>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import SessionService from '../../utils/SessionService'
export default {

  name: 'LoginViewComponent',

  data () {
    return {
      username: null,
      password: null,
      error: null,
      loading: false
    }
  },

  mounted () {
    document.body.classList.add('login-page')
  },
  destroyed () {
    document.body.classList.remove('login-page')
  },

  methods: {

    loginError (reason) {
      this.error = reason
    },

    login (username, password) {
      this.loading = true
      axios.post(`${process.env.API_ENDPOINT}/api/login`, {username, password}).then(response => {
        this.loading = false
        if (response.hasOwnProperty('data') && response.data.hasOwnProperty('token')) {
          let token = response.data.token
          this.$ls.set('token', token)
          this.$store.commit('app/setRoles', SessionService.getRoles(token))
          window.location.href = '/'
        } else {
          this.loginError('Nombre de usuario o contraseña incorrecto.')
        }
      }).catch(error => {
        this.loading = false
        this.loginError('Nombre de usuario o contraseña incorrecto.')
        console.log('error', error)
      })
    },

    loginSubmit () {
      this.login(this.username, this.password)
    }
  }
}
</script>

<style lang="scss" scoped>
    /*.float-right {*/
        /*float: right;*/
    /*}*/
</style>



// WEBPACK FOOTER //
// src/components/pages/PageLoginComponent.vue